import React, { useContext, useState } from 'react';
import t from '@/utils/Language/UI-translations';
import Button from '@/components/Button/Button';
import { AccountContext } from '@/context/account.context';
import { viewportContext } from '@/context/viewport.context';
import Bookmarks from '@/utils/api/odas/bookmarks';
import { toastContext } from '@/context/toast.context';
import { modalContext } from '@/context/modal.context';

const AddToBookmarkButton = ({ resource, buttonType, buttonShape, buttonBorder, hideOnMobile, additionalClasses, showButtonText = true }) => {
  const account = useContext(AccountContext);
  const { isXs } = useContext(viewportContext);
  const { addToast } = useContext(toastContext);
  const modal = useContext(modalContext);
  const [changeCounts, setChangeCounts] = useState({
    bookmarkChanged: false
  });

  const isBookmarked = () => {
    return account.bookmarks?.bookmarks?.find((bookmark) => bookmark.fetchable_id == resource.id);
  };

  const handleBookmarked = () => {
    if (!account.state.isLoggedIn) {
      modal.enqueueModal({ name: 'SignupModal' }, { forceOpen: true });
      return;
    }
    if (!isBookmarked()) {
      return Bookmarks.addBookmark({ fetchableType: resource.resource_type, fetchableId: resource.id })
        .then((response) => {
          account.updateBookmarkCollection({ action: 'add', bookmark: response.data.bookmark });
        })
        .catch((error) => {
          raiseError();
        });
    } else {
      return Bookmarks.delete({ fetchableType: resource.resource_type, fetchableId: resource.id })
        .then((response) => {
          const bookmark = { fetchable_type: resource.resource_type, fetchable_id: `${resource.id}` };
          account.updateBookmarkCollection({ action: 'remove', bookmark: bookmark });
          setChangeCounts((prevState) => ({ ...prevState, bookmarkChanged: !prevState.bookmarkChanged }));
          raiseRemoveSuccess();
        })
        .catch((error) => {
          raiseError();
        });
    }
  };
  const buttonText = (resource) => {
    if (!showButtonText) return '';
    if (isXs) {
      return '';
    } else {
      return isBookmarked() ? 'Bookmarked' : 'Bookmark';
    }
  };
  const raiseError = (message = false) => {
    addToast({
      message: message || t('An error occurred, please try again.'),
      type: 'error'
    });
  };

  const raiseRemoveSuccess = (message = false) => {
    addToast({
      message: message || t('You have successfully removed bookmark.'),
      type: 'success'
    });
  };
  const hasListChanges = () => {
    return changeCounts.bookmarkChanged;
  };

  return (
    <Button
      type={buttonType || 'default'}
      border={buttonBorder || false}
      shape={buttonShape || 'pill'}
      text={t(buttonText(resource))}
      icon={{ style: isBookmarked() ? 'fas' : 'far', font: 'bookmark' }}
      styles={{ hidden: isXs && hideOnMobile }}
      additionalClasses={additionalClasses}
      onButtonClick={handleBookmarked}
    />
  );
};

export default AddToBookmarkButton;
